import Notify from 'quasar/src/plugins/Notify.js';;

class NotificationService{
  createPositiveNotification(msg) {
    return Notify.create({
      message: msg,
      type: "positive",
      position: "top-right",
      timeout: 0,
      actions: [
        {
          icon: "close",
          color: "white",
          round: true,
        },
      ],
    });
  }

  createWarningNotification(errorMsg) {
    return Notify.create({
      message: errorMsg,
      type: "warning",
      position: "top-right",
      timeout: 0,
      actions: [
        {
          icon: "close",
          color: "white",
          round: true,
        },
      ],
    });
  }
}

export default new NotificationService();